import React from 'react';

const SvgNp = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="NP_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path
        d="M0 1.99C0 .892.903 0 1.994 0c.371 0 .924.168 1.223.367l14.337 9.558c.615.41.509.742-.217.742H8l9.663 8.455c.554.485.404.878-.339.878H1.998A1.999 1.999 0 0 1 0 18.01V1.99z"
        id="NP_svg__b"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <mask id="NP_svg__c" fill="#fff">
        <use xlinkHref="#NP_svg__b" />
      </mask>
      <use fill="#FFF" xlinkHref="#NP_svg__b" />
      <path
        d="M.667.667v18.666h16.225L6.226 10h10.239L2.848.922a1.977 1.977 0 0 0-.854-.255H.667zm16.674 9.937a.144.144 0 0 0-.01-.01z"
        stroke="#0543A8"
        strokeWidth={1.333}
        fill="#EE1B44"
        mask="url(#NP_svg__c)"
      />
      <path
        d="M6.851 7.8c.384-.104.738-.248 1.052-.424a2.668 2.668 0 0 1-5.143 0c.314.176.67.32 1.055.426l.518-.469-.847-.765 1.14.058-.058-1.14.765.847.766-.847-.059 1.14 1.141-.058-.848.765.518.468zM5.333 16l-1.02 1.13.078-1.52-1.521.077L4 14.667l-1.13-1.02 1.52.077-.077-1.521 1.02 1.13 1.02-1.13-.077 1.52 1.521-.077-1.13 1.02 1.13 1.021-1.52-.078.077 1.521L5.334 16z"
        fill="#FFF"
        mask="url(#NP_svg__c)"
      />
    </g>
  </svg>
);

export default SvgNp;
